import { AfterContentChecked, ChangeDetectorRef, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MultiSiteAwareComponent } from '~/infrastructure/multi-site-aware.component';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TabPosition, TabStripTabComponent } from '@progress/kendo-angular-layout';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { GridColumnMap } from '~/front-models/gridColumnMap';
import { DataWithPagingMetadata } from '~/infrastructure/paging';
import { AccountSummary } from '~/models/administration/account';
import { GridFieldAuthorization } from '~/models/administration/securityLevel';
import { UserSummary } from '~/models/administration/user';
import { Chart } from '~/models/chart/chart';
import { CustomFieldSummary } from '~/models/modules/customField';
import { GridFieldSummary } from '~/models/modules/gridField';
import { GridFieldTextSummary } from '~/models/modules/GridFieldText';
import { StartEndDateChartResponseModel } from '~/models/modules/startEndDateChartResponseModel';
import { VendorSummary } from '~/models/modules/vendor';
import { AccountsService } from '~/services/administration.ts/accounts';
import { FormatService } from '~/services/administration.ts/format';
import { BarcodeGeneratorsService } from '~/services/modules/stocks/barcode-generators';
import { CustomFieldsService } from '~/services/modules/stocks/custom-fields';
import { GridFieldsService } from '~/services/modules/stocks/gridField';
import { PurchaseOrdersService } from '~/services/modules/stocks/purchase-orders';
import { ReceiveTransactionsService } from '~/services/modules/stocks/receive-transactions';
import { VendorsService } from '~/services/modules/stocks/vendors';
import { SecurityService } from '~/services/security.service';
import { SharedService } from '~/services/sharedService';
import { ThemeManagerService } from '~/services/theme-manager';
import { GridLayoutManagerService } from '~/shared/components/grid/layout/grid-layout-manager';
import { LayoutManagerService, PORTAL_DATA } from '~/shared/components/layout/layout-manager';
import { LayoutComponent } from '~/shared/components/layout/layout.component';
import { SitesEnum } from '~/shared/enums/sites.enum';
import { PageState } from '~/shared/enums/stock-files.enum';
import { NoteComponent } from '~/shared/components/note/note.component';
import { GDataService } from '~/services/GDataService';
import { MultiSiteService } from '~/services/modules/common/multi-site.service';

@Component({
    selector: 'vendor-form',
    templateUrl: './upsert.html',
    styleUrls: ['./upsert.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StocksVendorsUpsertComponent extends MultiSiteAwareComponent implements OnInit, OnDestroy, AfterContentChecked {
  _deactivatedFormTabsForm: boolean = false
  _deactivatedFormTabsGridData: Array<any> = [];

  _currentUser: UserSummary;
  _kendoTabStripPosition: TabPosition = 'left';
  _innerWidth: any;
  _hiddenWindow: any;
  _maximized: any;
  _accountColumnsMap: GridColumnMap[] = [];
  _imageColumnsMap: GridColumnMap[] = [];
  _accounts: AccountSummary[];
  _selectedAccounts: any[] = [];
  _selectedImages: any[] = [];
  _selectedImagesKeys: number[] = [];
  _theme: string;
  // _isNew: boolean;
  _form: FormGroup;
  _active: boolean;
  _isAutoGeneratingNumber: boolean;
  _showImagesGrid: boolean;

  _invalidForm: boolean;
  _model: VendorSummary = null;
  _vendorsCode = new FormControl();
  _pageState: PageState;
  _addClassActive: boolean = false;
  _showCirclesForm: boolean;
  _tooltipVisibilityUpsert: boolean = true;
  _tooltipVisibilityForm: boolean = true;
  _isCustomfieldsFormValue: boolean = false;
  _isAddTabFormValue: boolean = false;
  _isRenameFormValue: boolean = false;
  _selectedTabId: number;
  _editFormActive: boolean;
  _page = 'vendors';
  _permissionScope = 'vendors';
  _customTabs: any;
  _orderingTabsForm: boolean = false;
  _customFieldsDictionary: { [key: string]: string } = {};
  _selectedLabelObjectCode: any;
  _language = 'en'
  _gridFieldText: GridFieldTextSummary[];
  //_selectedTabId: number;
  _customFields: CustomFieldSummary[][] = [];
  _customFieldsValue: any = [];
  _customValidation: any[] = [];
  _additionalErrors: any[] = [];
  _selectedLabelId: number;
  _selectedAccountIds: any[] = [];
  _isRenameLabel: boolean = false;
  _isRenameCustomFormValue: boolean = false;
  _custominvalidForm: boolean;
  _invalidSubmit: boolean;
  _isMandatory: boolean = false;
  _requiredFields: Array<any> = [];
  _requiredFieldNames: Array<any> = [];

  copyModelId: number;
  _customRequiredFields: Array<any> = [];
  public _donutChartSmall: any[] = [
    {
      data: [{
        category: 'Site 1',
        value: 120,
        color: '#fff6d9',
        colorLabel: '#ae8d2a',
        font: '10px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 2',
        value: 90,
        color: '#f2e2b1',
        colorLabel: '#ae8d2a',
        font: '10px -apple-system, BlinkMacSystemFont'
      }],
      sum: 210,
      title: 'DC Health'
    },
    {
      data: [{
        category: 'Site 1',
        value: 30,
        color: '#e7e0fc',
        colorLabel: '#321982',
        font: '10px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 2',
        value: 40,
        color: '#d1c7f0',
        colorLabel: '#321982',
        font: '10px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 3',
        value: 120,
        color: '#b3a5e3',
        colorLabel: '#321982',
        font: '10px -apple-system, BlinkMacSystemFont'
      }],
      sum: 180,
      title: 'Safe Workplace'
    },
    {
      data: [{
        category: 'Site 1',
        value: 30,
        color: '#e5fadd',
        colorLabel: '#458032',
        font: '10px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 2',
        value: 120,
        color: '#abd59d',
        colorLabel: '#458032',
        font: '10px -apple-system, BlinkMacSystemFont'
      }],
      sum: 150,
      title: 'District Logistics Center'
    }
  ];

  public _donutChartLarge: any[] = [
    {
      data: [{
        category: 'Site 1',
        value: 30,
        color: '#e5fadd',
        colorLabel: '#458032',
        font: '15px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 2',
        value: 120,
        color: '#abd59d',
        colorLabel: '#458032',
        font: '15px -apple-system, BlinkMacSystemFont'
      }],
      sum: 150,
      title: 'District Logistics Center'
    }
    ,
    {
      data: [{
        category: 'Site 1',
        value: 30,
        color: '#e7e0fc',
        colorLabel: '#321982',
        font: '15px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 2',
        value: 40,
        color: '#d1c7f0',
        colorLabel: '#321982',
        font: '15px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 3',
        value: 120,
        color: '#b3a5e3',
        colorLabel: '#321982',
        font: '15px -apple-system, BlinkMacSystemFont'
      }],
      sum: 180,
      title: 'Safe Workplace'
    },
    {
      data: [{
        category: 'Site 1',
        value: 120,
        color: '#fff6d9',
        colorLabel: '#ae8d2a',
        font: '15px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 2',
        value: 90,
        color: '#f2e2b1',
        colorLabel: '#ae8d2a',
        font: '15px -apple-system, BlinkMacSystemFont'
      }],
      sum: 210,
      title: 'DC Health'
    }
  ];

  okCloseSubscription: any = null;
  _deactivatedFieldsForm: boolean = false;
  _deactivatedFieldsGridData: any[] = [];

  _NOPActive: boolean = true;
  _RIActive: boolean = false;
  _RIBPNActive: boolean = false;
  _THActive: boolean = false;
  _BOActive: boolean = false;

  NumberItemForVendor: any;
  NumberPoForVendor: any;
  SummedOrderPastMonth: any;
  BackorderedStockVendor: any;


  reactivate: boolean = false;
  reactivateItem: any;


  GeneralSystemFields: Array<any> = [
    { title: 'VenContactNbr' },
    { title: 'VenNotes' }
  ];
  VendorAddressSystemFields: Array<any> = [
    { title: 'VenAddress1' },
    { title: 'VenAddress2' },
    { title: 'VenCity' },
    { title: 'VenState' },
    { title: 'VenZip' },
    { title: 'VenCountry' }
  ];
  VendorContactInfoSystemFields: Array<any> = [
    { title: 'VenContact' },
    { title: 'VenContactPhone1' },
    { title: 'VenContactPhone2' },
    { title: 'VenContactFax' },
    { title: 'VenContactEmail' },
  ];


  _index: number;
  _userNewDataTabs: Array<any> = [];
  _dataTabs: Array<any> = [];
  _dataTabsSelected: Array<any> = [];
  _systemFields: Array<any> = [];
  _editedSystemFields: Array<any> = [];
  _gridFieldAuth: GridFieldAuthorization[];
  _isLiveEnterprise: boolean;

  _datePickerFormat: string;
  _costFormat: string;

  _isEditForms: boolean = false;


  _poGridColumns: GridFieldSummary[];
  _receiveGridColumns: GridFieldSummary[];

  poChartForm: boolean;
  poBackOrderChartForm: boolean;
  transactionHistoryChartForm: boolean;

  numberOfPoChartDetail: StartEndDateChartResponseModel;
  numberOfPoChart: Chart;


  receiveItemsByCategoryChartDetail: StartEndDateChartResponseModel;
  receiveItemsByCategoryChart: Chart;
  receiveItemsByCategorySecondChart: Chart;

  receiveItemsByStockNumberChartDetail: StartEndDateChartResponseModel;
  receiveItemsByStockNumberChart: Chart;
  receiveItemsByStockNumberSecondChart: Chart;

  numberOfPoBackOrderByCategoryChartDetail: StartEndDateChartResponseModel;
  numberOfPoBackOrderByCategoryChart: Chart;

  transactionHistoryByVendorChartDetail: StartEndDateChartResponseModel;
  transactionHistoryByVendorChart: Chart;


  isNumberOfPoGridExpanded: boolean = true;
  isNumberOfPoChartExpanded: boolean = true;

  isBackOrderGridExpanded: boolean = true;
  isBackOrderChartExpanded: boolean = true;

  isTransactionHistoryGridExpanded: boolean = true;
  isTransactionHistoryChartExpanded: boolean = true;

  reloadlist: any;
  _vendors: any[];

  @ViewChild('kendo_tabstrip_wrapper') navTrigger: ElementRef;
  @ViewChild('kendo_BarcodeGen_Vendor_Code') kendoBarcodeGenVendorCode: ElementRef;
  @ViewChild('kendo_Input_Vendor_Name') kendoInputVendorName: ElementRef;
  @ViewChild('StockItemPerVendorTab') StockItemPerVendorTab: TabStripTabComponent;
  @ViewChild('POPerVendorTab') POPerVendorTab: TabStripTabComponent;
  @ViewChild('accountTab') accountTab: TabStripTabComponent;
  @ViewChild('mainWindow') kendoMainWindow: ElementRef;
  @ViewChild('note') note: NoteComponent;
  //#region Multi Site Variables

  //#endregion
  constructor(
    private _accountsService: AccountsService,
    private _vendorsService: VendorsService,
    private _fb: FormBuilder,
    private _themeManager: ThemeManagerService,
    private _layoutManager: LayoutManagerService,
    private _gridLayoutManagerService: GridLayoutManagerService,
    private _layoutComponent: LayoutComponent,
    private _barcodeGeneratorsService: BarcodeGeneratorsService,
    private _securityService: SecurityService,
    private _gridFields: GridFieldsService,
    private _customFieldsService: CustomFieldsService,
    public cdRef: ChangeDetectorRef,
    private _formatService: FormatService,
    private _sharedService: SharedService,
    private _purchaseOrdersService: PurchaseOrdersService,
    private _dataService: GDataService,
    private _receiveTransactionsService: ReceiveTransactionsService,
    private _multiSitesService: MultiSiteService
  ) {
    super();
    this._currentUser = this._securityService.currentUser;
    this._isLiveEnterprise = environment.liveEnterprise;

    this._getdata();

    this._themeManager.themeChange.subscribe((data) => {
      this._theme = data;
    });
    this._layoutManager.applyOverly();

    if (this._pageState == PageState.EDIT || this._pageState == PageState.VIEW || this._pageState == PageState.COPY) {
      this._selectedAccounts = (this._model?.vendorSites ?? []).map((item: any) => ({
        siteId: item.site?.id ?? item.siteId,
        accountId: item.account?.id ?? item.accountId
      }));
      this._selectedAccountIds = this._selectedAccounts.map((a: any) => +a.accountId);
      this._tabEnabled = this._selectedAccounts.length > 0;
    }
    this._currentUser = this._securityService.currentUser;

    //this.loadCustomFields(this._model?.id?.toString());
    this.loadLabels();


    this._customFieldsService.getDeactivatedCustomFields('stock', this._page).subscribe((data: Array<any>) => {
      this._deactivatedFieldsGridData = data.filter(x => x.formTab.page === this._page)
    });


    if (this._model && this._model.id) {
      this._vendorsService.getNumberItemForVendor(this._model.id).subscribe((x: any) => {
        this.NumberItemForVendor = x;
      });

      this._vendorsService.getNumberPoForVendor(this._model.id).subscribe((x: any) => {
        this.NumberPoForVendor = x;
      });

      this._vendorsService.getSummedOrderPastMonth(this._model.id).subscribe((x: any) => {
        this.SummedOrderPastMonth = x;
      });

      this._vendorsService.getBackorderedStockVendor(this._model.id).subscribe((x: any) => {
        this.BackorderedStockVendor = x;
      });
    }
  }

  _getdata() {
    this._model = this._sharedService.model && this._sharedService.model.model ? this._sharedService.model.model : null;
    this._pageState = this._sharedService.model && this._sharedService.model.pageState ? this._sharedService.model.pageState : null;
    this._active = true;

    if ((this._pageState === PageState.ADD || this._pageState === PageState.COPY) && this._model && this._model.id > 0) {
      this.copyModelId = this._model.id;
      this._model.id = null;
      this._model.code = null;
    }

    if (this._model && this._model.id) {
      this.LoadNumberOfPoChart();
      this.LoadReceivedItemsByCategoryByCustomer();
      this.LoadReceivedItemsByStockNumberByCustomer();
      this.LoadPoBackOrderByCustomer();
      this.LoadTransactionHistoryByCustomer();
      //this.initAllSitesDropDown(true, this._model.site);
    }
    if (!this._currentUser.isEnterprise) {
      if (this._model && this._model.site) {
        this._loadFormSites(true, this._model.site);
      }
      else {
        this._loadFormSites();
      }
    }
  }




  async LoadTransactionHistoryByCustomer() {
    this._vendorsService.GetTransactionHistoryByVendor(this._model.id).pipe().subscribe(async (data: any) => {
      this.transactionHistoryByVendorChartDetail = data;
      this.transactionHistoryByVendorChart = this.transactionHistoryByVendorChartDetail.chart;
    });


    this._gridFields.getGridFieldsByPage('receiveHistory').subscribe((data: any) => {
      this._gridLayoutManagerService.setGridColumnSubjects('receiveHistory', data);
      this._receiveGridColumns = data;
    });


  }


  async LoadNumberOfPoChart() {
    this._vendorsService.GetNumberOfPoByCustomer(this._model.id).pipe().subscribe(async (data: any) => {
      this.numberOfPoChartDetail = data;
      this.numberOfPoChart = data.chart;
    });

    this._gridFields.getGridFieldsByPage('purchaseOrders').subscribe((data: any) => {
      this._gridLayoutManagerService.setGridColumnSubjects('purchaseOrders', data);
      this._poGridColumns = data;
    });
  }



  _getPurchaseOrders = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    var startEndDate: any = {
      startDate: this.numberOfPoChartDetail.startDate,
      endDate: this.numberOfPoChartDetail.endDate
    }
    return this._purchaseOrdersService.GetPurchaseOrdersByVendor(this._model.id, startEndDate);
  }


  _getPurchaseOrdersBackOrder = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    var startEndDate: any = {
      startDate: this.numberOfPoBackOrderByCategoryChartDetail.startDate,
      endDate: this.numberOfPoBackOrderByCategoryChartDetail.endDate
    }
    return this._purchaseOrdersService.GetPurchaseOrderBackOrderByVendor(this._model.id, startEndDate);
  }



  _getReceiveTransactions = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    var startEndDate: any = {
      startDate: this.transactionHistoryByVendorChartDetail.startDate,
      endDate: this.transactionHistoryByVendorChartDetail.endDate
    }
    return this._receiveTransactionsService.GetReceiveTransactionByVendor(this._model.id, startEndDate);
  }


  async LoadReceivedItemsByStockNumberByCustomer() {
    this._vendorsService.GetReceiveItemsByStockNumberByCustomer(this._model.id).pipe().subscribe(async (data: any) => {

      this.receiveItemsByStockNumberChartDetail = data;
      this.receiveItemsByStockNumberChart = this.receiveItemsByStockNumberChartDetail.chart;
      this.receiveItemsByStockNumberSecondChart = this.receiveItemsByStockNumberChartDetail.secondChart;

      await this.FillChartSeriesChart(this.receiveItemsByStockNumberChart);
      await this.FillReceiveItemsByStockNumberChartSettings();
      await this.FillChartDataLabels(this.receiveItemsByStockNumberChart);
      await this.FillChartSeriesForQuarter(this.receiveItemsByStockNumberSecondChart);

    });

  }



  async LoadPoBackOrderByCustomer() {
    this._vendorsService.GetNumberOfPoBackOrderByCustomer(this._model.id).pipe().subscribe(async (data: any) => {
      this.numberOfPoBackOrderByCategoryChartDetail = data;
      this.numberOfPoBackOrderByCategoryChart = this.numberOfPoBackOrderByCategoryChartDetail.chart;
    });
  }





  async LoadReceivedItemsByCategoryByCustomer() {
    this._vendorsService.GetReceiveItemsByCategoryByCustomer(this._model.id).pipe().subscribe(async (data: any) => {
      this.receiveItemsByCategoryChartDetail = data;
      this.receiveItemsByCategoryChart = this.receiveItemsByCategoryChartDetail.chart;
      this.receiveItemsByCategorySecondChart = this.receiveItemsByCategoryChartDetail.secondChart;

      await this.FillChartSeriesChart(this.receiveItemsByCategoryChart);
      await this.FillReceivedItemsByCategoryChartSettings();
      await this.FillChartDataLabels(this.receiveItemsByCategoryChart);
      await this.FillChartSeriesForQuarter(this.receiveItemsByCategorySecondChart);

    });

  }




  async FillReceiveItemsByStockNumberChartSettings() {
    var chartSettings: any = {
      id: 'stockNumberBar',
      height: 280,
      type: 'bar',
      events: {
        dataPointSelection: (e: any, chart: any, opts: any) => {
          var quarterChartEl = document.querySelector('#chart-quarter');
          var monthChartEl = document.querySelector('#chart-receivedItem');

          if (opts.selectedDataPoints[0].length === 1) {
            if (quarterChartEl.classList.contains('active')) {
              this.updateQuarterChart(chart, 'barQuarter');
            } else {
              monthChartEl.classList.add('chart-quarter-activated');
              quarterChartEl.classList.add('active');
              this.updateQuarterChart(chart, 'barQuarter');
            }
          } else {
            this.updateQuarterChart(chart, 'barQuarter');
          }

          if (opts.selectedDataPoints[0].length === 0) {
            monthChartEl.classList.remove('chart-quarter-activated');
            quarterChartEl.classList.remove('active');
          }
        },
        updated: (chart: any) => {
          this.updateQuarterChart(chart, 'barQuarter');
        }
      }
    }


    this.receiveItemsByStockNumberChart.chart = chartSettings;
  }

  async FillReceivedItemsByCategoryChartSettings() {
    var chartSettings: any = {
      id: 'stockNumberBar',
      height: 280,
      type: 'bar',
      events: {
        dataPointSelection: (e: any, chart: any, opts: any) => {
          var quarterChartEl = document.querySelector('#chart-quarter');
          var monthChartEl = document.querySelector('#chart-receivedItem');

          if (opts.selectedDataPoints[0].length === 1) {
            if (quarterChartEl.classList.contains('active')) {
              this.updateQuarterChart(chart, 'barQuarter');
            } else {
              monthChartEl.classList.add('chart-quarter-activated');
              quarterChartEl.classList.add('active');
              this.updateQuarterChart(chart, 'barQuarter');
            }
          } else {
            this.updateQuarterChart(chart, 'barQuarter');
          }

          if (opts.selectedDataPoints[0].length === 0) {
            monthChartEl.classList.remove('chart-quarter-activated');
            quarterChartEl.classList.remove('active');
          }
        },
        updated: (chart: any) => {
          this.updateQuarterChart(chart, 'barQuarter');
        }
      }
    }


    this.receiveItemsByCategoryChart.chart = chartSettings;
  }



  async FillChartDataLabels(chart: Chart) {
    var dataLabels: any = {
      enabled: true,
      textAnchor: 'start',
      formatter: function (val: any, opt: any) {
        return opt.w.globals.labels[opt.dataPointIndex]
      }
    }
    chart.dataLabels = dataLabels;
  }


  async FillChartSeriesForQuarter(chart: Chart) {
    var series: any = [
      {
        name: 'quarter',
        data: []
      }
    ];

    chart.series = series;
  }



  public updateQuarterChart(sourceChart: any, destChartIDToUpdate: any) {
    var series = [];
    var seriesIndex = 0;
    var colors = [];

    if (sourceChart.w.globals.selectedDataPoints[0]) {
      var selectedPoints = sourceChart.w.globals.selectedDataPoints;
      for (var i = 0; i < selectedPoints[seriesIndex].length; i++) {
        var selectedIndex = selectedPoints[seriesIndex][i];
        var yearSeries = sourceChart.w.config.series[seriesIndex];
        series.push({
          name: yearSeries.data[selectedIndex].x,
          data: yearSeries.data[selectedIndex].quarters
        });
        colors.push(yearSeries.data[selectedIndex].color);
      }

      if (series.length === 0)
        series = [
          {
            data: []
          }
        ];

      return (window as any).ApexCharts.exec(destChartIDToUpdate, 'updateOptions', {
        series: series,
        colors: colors,
        fill: {
          colors: colors
        }
      });
    }
  }

  async FillChartSeriesChart(chart: Chart) {
    var series: any = [
      {
        name: chart.series[0].name,
        data: chart.series[0].data
      }
    ];


    chart.series = series;
  }



  ngAfterContentChecked(): void {
    this.cdRef.detectChanges();
  }


  ClosePopup(event: boolean) {
    if (event == true) {
      this._closeCustomFields();
    }
  }

  ngOnInit() {
    this._viewInactiveFormTabs(true);
    this._initForm();
    let windowSize = window.innerWidth;

    if (windowSize <= 991) {
      this._kendoTabStripPosition = 'top';
    } else {
      this._kendoTabStripPosition = 'left';
    }
    if (this._pageState == PageState.ADD || this._pageState == PageState.COPY) {
      setTimeout(() => {
        this.kendoBarcodeGenVendorCode.nativeElement.focus();
      }, 500);
    }
    if (!this._currentUser.isEnterprise) {
      this._tabEnabled = true;
    }
    this.getFormTabs();
    // this.getSystemFields();
    this.getSystemFieldsAndCustomFields();
    this.getAuth();
    //this.setMandatoryFields();
    /** Format */
    this._datePickerFormat = this._formatService.dateFormat;
    this._costFormat = this._formatService.costFormatValue;

    //this._loadVendorsDD();
  }
  //#region Multi Site Functions
  _loadFormSites(IsEdit: boolean = false, SavedSite: any = null) {
    this._multiSitesService.getAllSites().subscribe((data: any) => {
      this._sites = data || [];
      this._sitesFiltered = this._sites;

      this.initAllSitesDropDown(IsEdit, SavedSite);

    });
  }

  initAllSitesDropDown(isEdit: boolean = false, SavedSite: any = null) {
    super.initAllSitesDropDown(isEdit, SavedSite);
  }

  //#endregion

  _NOPTabClick() {
    this._RIActive = false;
    this._NOPActive = true;
    this._RIBPNActive = false;
    this._BOActive = false;
    this._THActive = false;
  }

  _RIPCTabClick() {
    this._RIActive = true;
    this._NOPActive = false;
    this._RIBPNActive = false;
    this._BOActive = false;
    this._THActive = false;
  }

  _RIBPNTabClick() {
    this._RIActive = false;
    this._NOPActive = false;
    this._RIBPNActive = true;
    this._BOActive = false;
    this._THActive = false;
  }

  _THTabClick() {
    this._RIActive = false;
    this._NOPActive = false;
    this._RIBPNActive = false;
    this._BOActive = false;
    this._THActive = true;
  }

  _BOTabClick() {
    this._RIActive = false;
    this._NOPActive = false;
    this._RIBPNActive = false;
    this._BOActive = true;
    this._THActive = false;
  }
  _viewInactiveFields() {
    this._customFieldsService.getDeactivatedCustomFields('stock', this._page).subscribe((data: Array<any>) => {
      this._deactivatedFieldsGridData = data.filter(x => x.formTab.page === this._page)
    });
    // this._deactivatedFieldsForm = true;
  }

  _closeInactiveFields() {
    this._deactivatedFieldsForm = false;
    //this._deactivatedFieldsGridData=[];
    this._customFieldsService.getDeactivatedCustomFields('stock', this._page).subscribe((data: Array<any>) => {
      this._deactivatedFieldsGridData = data.filter(x => x.formTab.page === this._page)
    });
  }



  PoChartFormOpen(event: any) {
    if ((event.target as HTMLElement).tagName != 'DIV')
      this.poChartForm = true;
  }

  PoChartFormClose() {
    this.poChartForm = false;
  }


  PoBackOrderChartFormOpen(event: any) {
    if ((event.target as HTMLElement).tagName != 'DIV')
      this.poBackOrderChartForm = true;
  }

  PoBackOrderChartFormClose() {
    this.poBackOrderChartForm = false;
  }


  TransactionHistoryChartFormOpen(event: any) {
    if ((event.target as HTMLElement).tagName != 'DIV')
      this.transactionHistoryChartForm = true;
  }

  TransactionHistoryFormClose() {
    this.transactionHistoryChartForm = false;
  }

  _reactivate(item: any) {

    this.reactivateItem = item;
    this.reactivate = true;
    const sub = this._sharedService.okCloseClicked.subscribe((data: boolean) => {
      if (data && this.reactivate) {
        this.reactivate = false;
        this._customFieldsService.reactivateCustomField(this.reactivateItem.id, item).subscribe((response: any) => {
          if (response != null && response['message'] != null) {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });
            if (response['close'] != null) {
              if (response['close'] == true) {
                //this.loadCustomFields(this._model?.id?.toString());
                this.getSystemFieldsAndCustomFields();
                // this._deactivatedFieldsForm = false;
              } else {
                return;
              }
            }
          }
          // this._deactivatedFieldsForm = false;
        });
        // this._deactivatedFieldsForm = false;
      } else {
        this.reactivate = false;
      }
      sub.unsubscribe();
    });

    this._layoutComponent.openPopup({
      title: 'Notification',
      message: 'Are you sure you want to Reactivate ' + item.name
    });
    //this.loadCustomFields(this._model?.id?.toString());
    this.getSystemFieldsAndCustomFields();
    this._customFieldsService.getDeactivatedCustomFields('stock', this._page).subscribe((data: Array<any>) => {
      this._deactivatedFieldsGridData = data.filter(x => x.formTab.page === this._page)
    });
  }

  _onEditFields() {

    if (!this._currentUser.isEnterprise) {
      this._pageState = PageState.EDIT_FIELDS;
      this._customFieldsService.getDeactivatedCustomFields('stock', this._page).subscribe((data: Array<any>) => {
        this._deactivatedFieldsGridData = data.filter(x => x.formTab.page === this._page)
      });
    }
    else {
      if (!this._selectedAccounts.length) {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please choose the account with the site desired',
          withoutConfirm: true
        });
      }
      else {
        this._pageState = PageState.EDIT_FIELDS;
        // this._editFormActive = true;
        // this._isCustomfieldsFormValue = true;
      }
    }
  }

  _addNewTab() {

    this._editFormActive = true;
    this._isAddTabFormValue = true;
    this._isRenameLabel = false;
    this._selectedLabelId = null;
  }
  _addNewField(tabId: number) {
    this._selectedTabId = null
    this._selectedTabId = tabId;
    this._editFormActive = true;
    this._isCustomfieldsFormValue = true;
    this._isRenameLabel = false;
  }
  _openRenameForm(objectCode: string, isMandatory: boolean = false) {
    this._selectedLabelObjectCode = objectCode; //todo send system field label id
    //return; //open form once label id is set

    this._editFormActive = true;
    this._isRenameFormValue = true;
    this._isRenameCustomFormValue = false;
    this._isRenameLabel = true;
    this._isMandatory = isMandatory;
  }
  _openCustomRenameForm(customFieldId: number, tabId: number) {
    this._selectedLabelId = customFieldId;
    this._selectedTabId = tabId;
    this._editFormActive = !isNaN(customFieldId);
    this._isRenameFormValue = !isNaN(customFieldId);
    this._isRenameCustomFormValue = !isNaN(customFieldId);
    this._isRenameLabel = false;
    this._isMandatory = false;
  }
  _returnAdNew() {
    this._pageState = PageState.ADD;
    if (this._deactivatedFormTabsGridData?.length == 0) {
      this._viewInactiveFormTabs(true);
    }
    this._customFieldsService.getDeactivatedCustomFields('stock', this._page).subscribe((data: Array<any>) => {
      this._deactivatedFieldsGridData = data.filter(x => x.formTab.page === this._page)
    });
  }
  _closeCustomFields() {
    this._editFormActive = false;
    this._isCustomfieldsFormValue = false;
    this._isAddTabFormValue = false;
    this._isRenameFormValue = false;
    //this.loadCustomFields(this._model?.id?.toString());
    this.getSystemFieldsAndCustomFields();
    this.loadLabels();
    this.getFormTabs();
    this.getAuth();
  }


  CheckIfWeAreInEditMode() {
    var isEditMode: boolean = false;

    if (this._pageState == PageState.EDIT) {
      isEditMode = true;
    }

    return isEditMode;
  }

  _edit() {
    this._pageState = PageState.EDIT;
    this.accountTab.selected = true;
    this.accountTab.disabled = true;
    this.StockItemPerVendorTab.disabled = true;
    this.POPerVendorTab.disabled = true;
  }
  _openCirclesForm() {
    this._showCirclesForm = true;
    this._tooltipVisibilityUpsert = false;
  }
  _closeCirclesForm() {
    this._showCirclesForm = false;
    this._tooltipVisibilityUpsert = true;
  }
  _getAccounts = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._accountsService.getAccounts(params, model);
  }

  _skipVendorName() {
    if (this._pageState == PageState.ADD) {
      let VendorName = this.kendoInputVendorName;
      VendorName.nativeElement.classList.remove('focusedInput');
      this._addClassActive = true;
      this.kendoInputVendorName.nativeElement.blur();
    }
  }
  _barcodeSubmited() {
    this._vendorsCode.setValue(this._form.get('code').value);
    if (this._pageState == PageState.ADD) {
      setTimeout(() => {
        let VendorName = this.kendoInputVendorName;
        VendorName.nativeElement.classList.add('focusedInput');
        this.kendoInputVendorName.nativeElement.focus();
      });
    }
  }
  _removeTabActiveAndSkipAdd() {
    if (this._pageState == PageState.ADD) {
      this._addClassActive = false;
      let VendorName = this.kendoInputVendorName;
      VendorName.nativeElement.classList.add('focusedInput');
    }
  }
  _vcremoveTabActiveAndSkipAdd() {
    if (this._pageState == PageState.ADD) {
      this._addClassActive = false;
      let VendorName = this.kendoInputVendorName;
      VendorName.nativeElement.classList.remove('focusedInput');
      VendorName.nativeElement.blur();
    }
  }

  _VendorNamecSubmited() {
    if (this._pageState == PageState.ADD) {
      let VendorName = this.kendoInputVendorName;
      VendorName.nativeElement.classList.remove('focusedInput');
      VendorName.nativeElement.blur();
      this._addClassActive = true;
    }
  }
  _VendorNameFocusout() {
    if (this._pageState == PageState.ADD) {
      setTimeout(() => {
        let VendorName = this.kendoInputVendorName;
        VendorName.nativeElement.classList.remove('focusedInput');
        VendorName.nativeElement.blur();
      }, 100);
    }
  }
  _generateBarcodeClick() {
    this.runGenerateBarcode();
  }
  private runGenerateBarcode() {
    let counter = 1;
    this.generateBarcode(counter)
      .subscribe((data: any) => {
        this._vendorsCode.setValue(data.result.toString());
        this._form.patchValue({
          code: data.result.toString()
        });
        if (this._pageState == PageState.ADD || this._pageState == PageState.COPY) {
          setTimeout(() => {
            let VendorName = this.kendoInputVendorName;
            VendorName.nativeElement.classList.add('focusedInput');
            this.kendoInputVendorName.nativeElement.focus();
          });
        }
      });
  }
  private generateBarcode(quantity: number) {
    return this._barcodeGeneratorsService
      .getBarcode('vendors', quantity);
  }

  _onStateChanges(e: any) {
    var element: any = this.kendoMainWindow;
    if (e === 'minimized') {
      element.el.nativeElement.classList.remove('fullWidthFormForm');
    }
    else if (e === 'maximized') {
      element.el.nativeElement.classList.remove('fullWidthFormForm');
    }
    else if (e === 'default') {
      element.el.nativeElement.classList.add('fullWidthFormForm');
    }
  }

  ngOnDestroy() {
    this._layoutManager.removeOverlay();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this._innerWidth = window.innerWidth;
    if (this._innerWidth > 450) {
      this._hiddenWindow = 'hidden';
      this._maximized = 'maximized';
    } else {
      this._hiddenWindow = '';
      this._maximized = 'default';
    }
    let windowSize = window.innerWidth;

    if (windowSize <= 991) {
      this._kendoTabStripPosition = 'top';
    } else {
      this._kendoTabStripPosition = 'left';
    }
  }

  _onTabSelect(e: any) {
    this._mobileMenuToggle();
  }

  _mobileMenuToggle() {
    let mobiletabstrip = this.navTrigger.nativeElement.querySelector('ul');
    mobiletabstrip.classList.toggle('visibletab');
  }

  _onSave(e: any) {
    this.submit(e);
  }

  _onEditForm() { }

  _onCancel() {
    this._closeForm();
  }


  _loadVendorsDD() {

    return this._vendorsService.getVendorsListing()
      .subscribe((data: any) => {
        this._vendors = data;

      });
  }

  _closeForm(vendorId: any = null) {

    this.reloadlist = this._sharedService.model.reload;

    var closeComponent = {
      component: 'vendors',
      isClosed: true,
      response: this.reloadlist === undefined ? null : vendorId
    };

    this._active = false;
    this._gridLayoutManagerService.setGridDataSubjects('vendors');
    this._layoutManager.setFromChanged('vendors');
    this.ngOnDestroy();
    this._vendorsService.vendorFormClosed(this._form.get('code').value ?? '');
    this._sharedService.closeDialog.emit(closeComponent);
    this._sharedService.model = {};
    //Quraim
    this._dataService.push(closeComponent);
    this._sharedService.model = {};

  }

  _onAccountRowSelectionChanges(e: any[]) {
    super._onAccountRowSelectionChanges(e);
  }

  private _initForm() {
    this._form = this._fb.group({
      id: [this._model && this._model.id],
      code: [this._model && this._model.code, Validators.required],
      name: [this._model && this._model.name, this.getLabel('LBL_VenName')?.isRequired ? Validators.required : null],
      notes: [this._model && this._model.notes, this.getLabel('LBL_VenNotes')?.isRequired ? Validators.required : null],
      vendorcontractnumber: [this._model && this._model.entityContract && this._model.entityContract.number, this.getLabel('LBL_VenContact#')?.isRequired ? Validators.required : null],
      vendorcertificationdate: [this._model && this._model.entityContract?.certdate ? new Date(this._model.entityContract?.certdate) : null, this.getLabel('LBL_CertificationDate')?.isRequired ? Validators.required : null],
      addressLine1: [this._model && this._model.entityAddress && this._model.entityAddress.addressLine1, this.getLabel('LBL_VenAddress1')?.isRequired ? Validators.required : null],
      addressLine2: [this._model && this._model.entityAddress && this._model.entityAddress.addressLine2, this.getLabel('LBL_VenAddress2')?.isRequired ? Validators.required : null],
      addresscity: [this._model && this._model.entityAddress && this._model.entityAddress.city, this.getLabel('LBL_VenCity')?.isRequired ? Validators.required : null],
      addressstate: [this._model && this._model.entityAddress && this._model.entityAddress.state, this.getLabel('LBL_VenState')?.isRequired ? Validators.required : null],
      addresszip: [this._model && this._model.entityAddress && this._model.entityAddress.zip, this.getLabel('LBL_VenZip')?.isRequired ? Validators.required : null],
      addresscountry: [this._model && this._model.entityAddress && this._model.entityAddress.country, this.getLabel('LBL_VenCountry')?.isRequired ? Validators.required : null],
      addressPhone1: [this._model && this._model.entityAddress && this._model.entityAddress.phone1, this.getLabel('LBL_AddressPhone1')?.isRequired ? Validators.required : null],
      addressPhone2: [this._model && this._model.entityAddress && this._model.entityAddress.phone2, this.getLabel('LBL_AddressPhone2')?.isRequired ? Validators.required : null],
      addressFax: [this._model && this._model.entityAddress && this._model.entityAddress.fax, this.getLabel('LBL_AddressFax')?.isRequired ? Validators.required : null],
      addressEmail: [this._model && this._model.entityAddress && this._model.entityAddress.email, this.getLabel('LBL_AddressEmail')?.isRequired ? Validators.required : null],
      addressWebsite: [this._model && this._model.entityAddress && this._model.entityAddress.website, this.getLabel('LBL_AddressWebsite')?.isRequired ? Validators.required : null],
      contactperson: [this._model && this._model.entityContact && this._model.entityContact.person, this.getLabel('LBL_VenContact')?.isRequired ? Validators.required : null],
      contactphone1: [this._model && this._model.entityContact && this._model.entityContact.phone1, this.getLabel('LBL_VenContactPhone1')?.isRequired ? Validators.required : null],
      contactphone2: [this._model && this._model.entityContact && this._model.entityContact.phone2, this.getLabel('LBL_VenContactPhone2')?.isRequired ? Validators.required : null],
      contactfax: [this._model && this._model.entityContact && this._model.entityContact.fax, this.getLabel('LBL_VenContactFax')?.isRequired ? Validators.required : null],
      contactemail: [this._model && this._model.entityContact && this._model.entityContact.email, this.getLabel('LBL_VenContactEmail')?.isRequired ? Validators.required : null]
    });
  }

  private submit = (e: string) => {
    var sitesSelected: boolean = true;
    if (this._currentUser.isEnterprise) {
      if (this._currentUser.isEnterprise && this._selectedAccounts.length === 0) {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please select account(s) to continue.',
        });
        return false;
      }
      else {
        var tmpAccountSites = this._selectedAccounts.filter(
          (x: any) => x.siteId != -1
        );
        if (tmpAccountSites.length != this._selectedAccounts.length) {
          this._layoutComponent.openPopup({
            title: 'Validation',
            message: 'Please select the site(s) of the selected account(s) to continue.',
          });
          sitesSelected = false;
          return false;
        }
      }
    }
    if (this._form.invalid && this._customValidation.find((x: any) => !x.value)) {
      this._invalidForm = true;
      this._invalidSubmit = true;
      this._additionalErrors.push("Additional Error");
      this._additionalErrors = [];
    }
    else if (this._form.invalid) {
      this._invalidForm = true;
    }
    else if (this._customValidation.find((x: any) => !x.value)) {
      this._additionalErrors.push("Additional Error");
      this._additionalErrors = [];
      this._invalidSubmit = true;
      this._invalidForm = true;
    } else {

      // work with custom fields
      if (this._customFieldsValue) {
        // const entries = Object.entries(this._customFieldsValue);
        // for (const [index, [key, value]] of entries.entries()) {
        //   this._customFieldsDictionary[key] = `${value}`;
        // }
        this._customFieldsValue.forEach((elementy: any) => {
          this._customFieldsDictionary[elementy.Key] = elementy.Value;
        });
      }
      //

      this._invalidForm = false;
      this._invalidSubmit = false;
      const model = this._form.value;
      model['customFieldsValue'] = this._customFieldsDictionary;
      model['accountSites'] = [];
      var tmpAccountSites = this._selectedAccounts.filter((x: any) => x.siteId != -1);
      tmpAccountSites.forEach((item) => {

        if (model['accountSites'].filter((x: any) => x.siteId == item.siteId && x.accountId == item.accountId).length == 0) {
          model['accountSites'].push(item);
        }

      });

      model['entityContract'] = {
        number: model.vendorcontractnumber,
        certdate: model.vendorcertificationdate != null ? new Date(model.vendorcertificationdate).toLocaleDateString() : null
      };
      model['entityAddress'] = {
        addressLine1: model.addressLine1,
        addressLine2: model.addressLine2,
        city: model.addresscity,
        state: model.addressstate,
        zip: model.addresszip,
        country: model.addresscountry,
        Phone1: model.addressPhone1,
        Phone2: model.addressPhone2,
        Fax: model.addressFax,
        Email: model.addressEmail,
        Website: model.addressWebsite,
      };
      model['entityContact'] = {
        person: model.contactperson,
        phone1: model.contactphone1,
        phone2: model.contactphone2,
        fax: model.contactfax,
        email: model.contactemail,
      };
      model["siteId"] = this._siteSelected?.id;
      if (this._pageState == PageState.EDIT || this._pageState == PageState.VIEW) {
        if (this._model.id == null) {
          this._model.id = model.id;
        }

        this._vendorsService.updateVendor(this._model.id, model).subscribe((response: any) => {

          if (response != null && response['message'] != null) {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });

            if (response['close'] != null) {
              if (response['close'] == true) {
                model.id = this._model.id;
                this._vendorsService.vendorUpdated.emit(model);
                if (e === 'saveAndClose') {
                  this._closeForm();
                }
                else if (e === 'saveAndCopy') {
                  this.copyModelId = this._model.id;
                  this._form.controls.code.setValue(null);
                  this._pageState = PageState.ADD;
                  this.loadCustomFields();
                }
                else if (e === 'save') {
                  this._pageState = PageState.EDIT;
                }
                else if (e === 'saveAndNew') {
                  this._initForm();
                  this._form.reset();
                  this._pageState = PageState.ADD;
                }
              } else {
                return;
              }
            }
          }

        });
      } else {
        this._vendorsService.createVendor(model).subscribe((response: any) => {

          if (response != null && response['message'] != null) {
            if (!this._currentUser.isEnterprise) {
              this.note.createNote(response.responseId);
            }
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });

            if (response['close'] != null) {
              if (response['close'] == true) {
                model.id = response.responseId;
                this._vendorsService.vendorAdded.emit(model);

                if (e === 'saveAndClose') {
                  this._closeForm(model);
                }
                else if (e === 'saveAndCopy') {
                  this._form.controls.code.setValue(null);
                  this._pageState = PageState.ADD;
                }
                else if (e === 'save') {
                  this._pageState = PageState.EDIT;
                  this._model.id = response.responseId;
                }
                else if (e === 'saveAndNew') {
                  this._initForm();
                  this._form.reset();
                  this._pageState = PageState.ADD;
                }
              } else {
                return;
              }
            }
          }
        });
      }
    }
  }


  _customFieldsValueChanges(customFieldsValue: any, tabId: number) {
    /* Object.keys(customFieldsValue).forEach(key => {
      if (customFieldsValue[key] == null || customFieldsValue[key] == 'null') {
        customFieldsValue[key] = '';
      }
      if (this._customFields[tabId].find(x => x.name == key).entityId == undefined) {//new mode, custom field data not added yet
        this._customFields[tabId].find(x => x.name == key).entityId = -1;
        this._customFields[tabId].find(x => x.name == key).customFieldsData.push({ id: -1, value: 'null', entityId: -1 ,customFieldId:-1 });
      }
      var customFieldData = this._customFields[tabId].find(x => x.name == key).customFieldsData.find(x => x.entityId == this._customFields[tabId].find(x => x.name == key).entityId);
      if (customFieldData != undefined) {
        customFieldData.value = customFieldsValue[key];
      }
    });
    this._customFieldsValue = customFieldsValue; */
    Object.keys(customFieldsValue).forEach((key) => {
      let customObject = {
        Key: key,
        Value: customFieldsValue[key],
      };
      let item = null;
      this._customFieldsValue.forEach((elementz: any) => {
        if (elementz.Key == key) {
          item = elementz;
        }
      });
      if (item != null) {
        let index = this._customFieldsValue.indexOf(item);
        if (index != -1) {
          this._customFieldsValue.splice(index, 1);
        }
      }
      var requiredCustomerField = this._customValidation.find(
        (x: any) => x.name == key
      );
      if (requiredCustomerField) {
        let item2 = null;
        this._customValidation.forEach((element: any) => {
          if (element.name == key) {
            item2 = element;
          }
        });
        if (item2 != null) {
          let index2 = this._customValidation.indexOf(item2);
          if (index2 != -1) {
            //this._customValidation.splice(index2, 1);
            this._customValidation[index2].value = customObject.Value;
          }
          //this._customValidation.push({'name': customObject.Key, 'value': customObject.Value})
        }
      }
      this._additionalErrors = [];
      if (this._customValidation.find((x: any) => !x.value)) {
        this._additionalErrors.push("Additional Error");
        this._additionalErrors = [];
      }

      this._customFieldsValue.push(customObject);
    });
  }

  _removeCustomField(customFieldId: number) {
    for (var i = 1; i <= this._customFields.length; i++) {
      if (this._customFields[i] != null) {
        if (this._customFields[i].findIndex(x => x.id == customFieldId) != -1) {
          this._customFields[i] = this._customFields[i].filter(x => x.id != customFieldId);
          return;
        }
      }
    }
  }
  _viewInactiveFormTabs(onLoad: boolean = false) {
    this._customFieldsService
      .getDeactivatedCustomForms(this._page)

      .subscribe((data: Array<any>) => {
        this._deactivatedFormTabsGridData = data;
        //  if(!onLoad)
        //  this._deactivatedFormTabsForm = true;
      });
  }
  reactivateTab: boolean;
  _reactivateFormTab(item: any) {
    this.reactivateTab = true;
    const sub = this._sharedService.okCloseClicked.subscribe((boolData: boolean) => {
      this.reactivateTab = true;
      if (boolData && this.reactivateTab) {
        // if (boolData && this.reactivateTab && (this.lastTabIdReactivated.length == 0 || !this.lastTabIdReactivated.includes(item.id))) {
        this.reactivateTab = false;
        let model: any = {
          customFieldEntityId: 1,
          page: this._page,
          accountIds: this._selectedAccountIds,
        };
        this._customFieldsService
          .reactivateFormTab(item.id, model)

          .subscribe((response: any) => {
            if (response != null && response['message'] != null) {
              // if (this.lastTabIdDeactivated.includes(item.id)) {
              //   this.lastTabIdDeactivated = this.lastTabIdDeactivated.filter(id => id !== item.id);
              // }
              // this.lastTabIdReactivated.push(item.id);
              this._viewInactiveFormTabs(false)
              this._customFieldsService
                .getFormTabsByPage(this._page)

                .subscribe((data: any) => {
                  //get custom tabs first
                  this.getFormTabs();
                  this._customTabs = data.filter((x: { isCustom: boolean; }) => x.isCustom == true);
                });
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response['message'],
                withoutConfirm: true
              });
              if (response['close'] != null) {
                if (response['close'] == true) {
                } else {
                  return;
                }
              }
            }
          });
      } else {
        this.reactivateTab = false;
      }
      sub.unsubscribe();
    });


    this._layoutComponent.openPopup({
      title: 'Notification',
      message: 'Are you sure you want to Reactivate ' + item.name
    });
    //this.loadCustomFields(this._model?.id?.toString());
    this.getSystemFieldsAndCustomFields();
  }
  _closeInactiveFormTabs() {
    this._deactivatedFormTabsForm = false;
  }
  // lastTabIdDeactivated:number[] = []
  // lastTabIdReactivated:number[] = []
  //#endregion
  deactivateTab: boolean
  _deactivateTab(tabId: number, page: string) {
    this.deactivateTab = true;
    const sub = this._sharedService.okCloseClicked.subscribe((boolData: boolean) => {
      if (boolData && this.deactivateTab) {
        // if (boolData && this.deactivateTab && (this.lastTabIdDeactivated.length == 0 || !this.lastTabIdDeactivated.includes(tabId))) {
        this.deactivateTab = false;
        let model: any = {
          customFieldEntityId: 1,
          page: this._page,
          accountIds: this._selectedAccountIds,
        };
        this._customFieldsService.deleteCustomTab(tabId, model).subscribe((response: any) => {
          // this.lastTabIdDeactivated.push(tabId);
          // if (this.lastTabIdReactivated.includes(tabId)) {
          //   this.lastTabIdReactivated = this.lastTabIdReactivated.filter(id => id !== tabId);
          // }

          if (response != null && response['message'] != null) {
            this._customFieldsService.getFormTabsByPage(this._page).subscribe((data: any) => {
              //get custom tabs first
              this.getFormTabs();
              this._customTabs = data.filter((x: { isCustom: boolean }) => x.isCustom == true);
            });

            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });

            if (response['close'] != null) {
              if (response['close'] == true) {
                // this._closeForm();
              }
              else {
                return;
              }
            }
          }
        });
      } else {
        this.deactivateTab = true;
      }
      sub.unsubscribe();
    });

    this._layoutComponent.openPopup({
      title: 'Notification',
      message: 'Are you sure you want to Deactivate This Tab?',
    });

  }


  // _deactivateTab(tabId: number, page: string) {
  //   let model: any = {
  //     customFieldEntityId: page == 'vendors' ? 1 : 2,
  //     page: this._page,
  //     accountIds: this._selectedAccountIds,
  //   };
  //     .deleteCustomTab(tabId, model)
  //     
  //     .subscribe((response: any) => {
  //       if (response != null && response['message'] != null) {
  //           .getFormTabsByPage(this._page)
  //           
  //           .subscribe((data: any) => {
  //             //get custom tabs first
  //             this._customTabs = data.filter((x: { isCustom: boolean; }) => x.isCustom == true);
  //           });
  //         this._layoutComponent.openPopup({
  //           title: 'Alert',
  //           message: response['message'],
  //           withoutConfirm: true
  //         });
  //         if (response['close'] != null) {
  //           if (response['close'] == true) {

  //           } else {
  //             return;
  //           }
  //         }
  //       }

  //     });

  // }

  _reorderingtabs() {

    this._orderingTabsForm = true;
  }

  _closeOrderingTabsForm() {
    this._orderingTabsForm = false;
    this._dataTabsSelected = this._userNewDataTabs;
  }

  private loadCustomFields(entityId?: string) {
    entityId = this.copyModelId?.toString() ?? this._model?.id?.toString();
    this._customFieldsService.getCustomFields('stock', this._page, entityId).subscribe((data) => {
      if (this._model != null && this._model.id != null || this.copyModelId != null) {
        let that = this;
        data.map(function (x) {
          x.entityId = that._model.id ?? that.copyModelId;
        });
      }

      var tabIds = data.map(item => item.formTabId).filter((value, index, self) => self.indexOf(value) === index);

      const grouped = this.groupBy(data, (item: { formTabId: any; }) => item.formTabId);
      let that = this;
      tabIds.forEach(function (formTabId) {
        that._customFields[formTabId] = grouped.get(formTabId);
      });

      if (this.copyModelId) {
        let CustomFieldsDataForCopy: any = {};
        grouped.forEach(element => {
          element.forEach((value: any) => {

            let _cutomfieldData = value.customFieldsData?.find((f: any) => f.entityId == entityId);
            CustomFieldsDataForCopy[value.name] = _cutomfieldData?.value ?? null;

            if (value.customFieldType.type.toLowerCase() == 'date' && CustomFieldsDataForCopy[value.name]) {
              CustomFieldsDataForCopy[value.name] = new Date(CustomFieldsDataForCopy[value.name]);
            }

            if (value.customFieldType.type.toLowerCase() == 'numeric' && CustomFieldsDataForCopy[value.name]) {
              CustomFieldsDataForCopy[value.name] = parseFloat(CustomFieldsDataForCopy[value.name]);
            }

          });
          this._customFieldsValueChanges(CustomFieldsDataForCopy, null);

        });
      }

      this._customFieldsService.getFormTabsByPage(this._page).subscribe((data: any) => {
        //get custom tabs first
        this._customTabs = data.filter((x: { isCustom: boolean }) => x.isCustom == true);
        this.setMandatoryFields();
      });
    });


  }

  groupBy(list: any[], keyGetter: any) {
    const map = new Map();
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  }



  private loadLabels() {
    this._gridFields.getGridFieldTextLabelByPage(this._page, this._language)

      .subscribe((data: GridFieldTextSummary[]) => {
        this._gridFieldText = data;
        this._initForm();
      })
  }

  getLabel(objectCode: any) {
    if (this._gridFieldText) {


      if (this._gridFieldText.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode))
        var result = this._gridFieldText.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode)
      else
        result = null

      return result ? result : null;
    }
  }

  formStatus(isInvalid: boolean) {
    this._custominvalidForm = isInvalid;
  }



  _comboValueChange(e: any, i: number) {
    if (this._dataTabsSelected.find(x => x.order == i + 1)) {
      this._userNewDataTabs.find(x => x === this._dataTabsSelected.find(x => x.order == i + 1)).order =
        this._dataTabsSelected.find(x => x.name === e.name).order;
    }
    this._userNewDataTabs.find(obj => obj.name == e.name).order = i + 1;
    this._dataTabsSelected = this._dataTabsSelected.filter(obj => obj !== e);
  }

  _onSaveTabOrdering() {
    this._gridFields.updateFormTabsReorder(this._userNewDataTabs).subscribe((x: any) => {
      this._dataTabs = x;
      this._closeOrderingTabsForm();
    })
  }


  getFormTabs() {
    this._gridFields.getformTabsByPage(this._page).subscribe((x: any) => {
      this._dataTabs = x;
      this._dataTabsSelected = x;
      this._userNewDataTabs = x;
      //this.sortProduct(p => p.order, "ASC");
    });
  }

  getSystemFields() {
    this._gridFields.getSystemFieldsByPage(this._page).subscribe((x: any) => {
      this._systemFields = x;
      this._editedSystemFields = x;
    })
  }
  getSystemFieldsAndCustomFields() {
    this._gridFields.getSystemFieldsByPage(this._page).subscribe((x: any) => {
      this._systemFields = x;
      this._editedSystemFields = x;
      this.loadCustomFields(this._model?.id?.toString());
      //this.setMandatoryFields();
    })

  }

  dataMove(newLocData: any, oldLocData: any) {
    const sysF: any[] = this._systemFields;
    const sysFClone: any[] = [];

    sysF.forEach((element: any) => {
      sysFClone.push(Object.assign({}, element))
    });

    this._systemFields.find(x => x.id === oldLocData.id).formOrder = sysFClone.find(x => x.id === newLocData.id).formOrder;
    this._systemFields.find(x => x.id === newLocData.id).formOrder = sysFClone.find(x => x.id === oldLocData.id).formOrder;

    this._editedSystemFields = this._systemFields;
  }

  dragEnd() {
    this._gridFields.updatedSystemFieldReorder(this._editedSystemFields).subscribe((x: any) => {
      this._systemFields = x;
      this._editedSystemFields = x;
    })
  }

  getAuth() {
    // this._gridFields.getFileAuthorization(this._auth, this._currentUser.appRole.id)
    this._gridFields.getFieldsAuthorization(this._page, this._currentUser.appRole.id).subscribe((x: GridFieldAuthorization[]) => {
      this._gridFieldAuth = x;
    });
  }

  getAuthByLabel(objectCode: any) {
    if (this._gridFieldAuth) {
      if (this._gridFieldAuth.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode)) {
        var result = this._gridFieldAuth.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode)
      }
      else {
        result = null
      }

      return result ? result : new GridFieldAuthorization();
    }
  }

  requiredSystemTabs: any = [];

  setMandatoryFields() {
    this._requiredFieldNames = [];
    this._requiredFields = [];
    this.requiredSystemTabs = [];
    setTimeout(() => {

      for (let item of this._systemFields) {
        if (item.gridFieldText?.isRequired) {
          this._requiredFields.push(item);
        }
      }

      for (let item2 of this._customFields) {
        if (item2) {
          for (let item3 of item2) {
            if (item3.isRequired) {
              this._requiredFields.push(item3);
            }
          }
        }
      }

      this._requiredFields.forEach(element => {
        if (!element.isCustomField && element.isCustomField == null) {
          var tabName = element.formTab;
          this._requiredFieldNames.push(tabName);
        }
        else {
          if (element.formTabId) {
            let SystemFieldTab = this._dataTabs.find(x => x.id == element.formTabId);
            if (SystemFieldTab)
              this.requiredSystemTabs.push(SystemFieldTab);
          }
        }
      });
      if (this.navTrigger) {
        let tabElementList = this.navTrigger.nativeElement.querySelector('ul');
        Array.from(tabElementList.children).forEach((child: any) => {

          child.classList.remove('mendatoryTab');
        });
        Array.from(tabElementList.children).forEach((child: any) => {
          if (this._requiredFieldNames.find(x => x.name === child.firstChild.innerText && (x.page ? x.page == this._page : x.formtab.page == this._page))) {
            child.classList.add('mendatoryTab')
          }
          if (
            this.requiredSystemTabs.find(
              (x: any) =>
                x.name === child.firstChild.innerText
                || (child.firstChild.innerText == 'Address' && x.name === 'Address/Phone')
            )
          ) {
            child.classList.add('mendatoryTab');
          }
        });
      }
      this._requiredFields.forEach((element) => {
        if (element.customFieldType) {
          this._customRequiredFields.push(element);
          let thisvalue = element.customFieldsData.filter((x: any) => x.entityId == (this._model.id > 0 ? this._model.id : this.copyModelId)).length > 0
            ? element.customFieldsData.filter((x: any) => x.entityId == (this._model.id > 0 ? this._model.id : this.copyModelId))[0].value
            : '';

          this._customValidation.push({
            name: element.name,
            value: thisvalue,
            tabName: element.formTab?.name,
          });
        }
      });

    }, 500);
  }

  _onEditForms() {
    this._isEditForms = true;
  }

  _onCloseEditForms(event: boolean) {
    this._isEditForms = event;
  }

  ExpandCollapseNumberOfPoGrid(isExpand: boolean) {
    this.isNumberOfPoGridExpanded = !isExpand;
  }

  ExpandCollapseNumberOfPoChart(isExpand: boolean) {
    this.isNumberOfPoChartExpanded = !isExpand;
  }


  ExpandCollapseBackOrderGrid(isExpand: boolean) {
    this.isBackOrderGridExpanded = !isExpand;
  }

  ExpandCollapseBackOrderChart(isExpand: boolean) {
    this.isBackOrderChartExpanded = !isExpand;
  }


  ExpandCollapseTransactionHistoryGrid(isExpand: boolean) {
    this.isTransactionHistoryGridExpanded = !isExpand;
  }


  ExpandCollapseTransactionHistoryChart(isExpand: boolean) {
    this.isTransactionHistoryChartExpanded = !isExpand;
  }

  canAccess(scope: string, operation: string): boolean {
    return this._securityService.hasPermission(null, `${scope}-${operation}`);
  }
}
